<!-- add category modal -->
<div
  class="modal fade"
  id="add"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ incomeI18n?.addButtonI18n }}
        </h5>
        <button
          type="button"
          id="close"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-add-income
          [incomeI18n]="incomeI18n"
          (closeModalEvent)="closeModalAdd()"
        ></app-add-income>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {{ incomeI18n?.closeButtonI18n }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- edit category modal -->
<div
  class="modal fade"
  id="edit"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          {{ "categoryI18n?.editButtonI18n" }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-edit-income
          (closeModalEvent)="closeModalEdit()"
          [id]="id"
        ></app-edit-income>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {{ "categoryI18n?.closeButtonI18n" }}
        </button>
      </div>
    </div>
  </div>
</div>
